import React from 'react';
import Logo from '../assets/img/logo_animation.svg';

const LoadingMainApp = ({ message }) => (
	<div
		style={{
			display: 'flex',
			height: '100vh',
			width: '100vw',
			alignItems: 'center',
			justifyContent: 'center',
			flexDirection: 'column'
		}}
	>
		<img src={Logo} className="logo" alt="councilbox logo"></img>
		<div>
			{message}
		</div>
	</div>
);

export default LoadingMainApp;
